import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {formatDate} from '@angular/common';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-calendar-dialog',
  templateUrl: './calendar-dialog.component.html',
  styleUrls: ['./calendar-dialog.component.scss']
})
export class CalendarDialogComponent implements OnInit {
  weekDays: any = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  months: any = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  monthDays: Array<Array<string>>;
  selectedYear: number; //Calendar year change
  selectedMonth: number; //Calendar month change
  selectedDate: Date; //Date selected by customer
  date: Date = new Date();

  constructor(public dialogRef: MatDialogRef<CalendarDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private shared: SharedService) {
    if (data.date) this.selectedDate = new Date(data.date);
    this.date = this.selectedDate || this.date;
    this.selectedYear = this.date.getFullYear();
    this.selectedMonth = this.date.getMonth();
    this.changeDisplayMonth(this.selectedYear, this.selectedMonth);
  }

  ngOnInit() {
  }

  changeDisplayMonth(year, month) {
    let lastDay = new Date(year, month + 1, 0);
    this.monthDays = [];
    let week = [];
    for (let i = 1; i < lastDay.getDate() + 1; i++) {
      let dayOfWeek = new Date(year, month, i, 12).getDay();
      week.push(i);
      if (dayOfWeek == 6 || i == lastDay.getDate()) {
        if (week.length < 7 && !this.monthDays.length) {
          for (let z = 1, l = week.length; z <= 7 - l; z++) {
            week.unshift(0);
          }
        }
        this.monthDays.push(week);
        week = [];
      }

    }
  }

  nextMonth() {
    if (this.selectedMonth == 11) {
      this.selectedMonth = 0;
      this.selectedYear++;
    } else {
      this.selectedMonth++;
    }
    this.changeDisplayMonth(this.selectedYear, this.selectedMonth);
  }

  prevMonth() {
    if (this.selectedMonth == 0) {
      this.selectedMonth = 11;
      this.selectedYear--;
    } else {
      this.selectedMonth--;
    }
    this.changeDisplayMonth(this.selectedYear, this.selectedMonth);
  }

  dateUnavailable(year, month, day) {
    return !(this.isDateToday(year, month, day) || this.isDateToday(year, month, day - 1));
  }

  isDateToday(year, month, day) {
    let check = new Date(year, month, day);
    let nowDate = new Date();
    let dateCheck = formatDate(check, 'yyyyMMdd', 'en-US');
    let nowDateLong = formatDate(nowDate, 'yyyyMMdd', 'en-US');
    return parseInt(dateCheck) == parseInt(nowDateLong);
  }

  isSelectedDate(year, month, day) {
    if (this.selectedDate) {
      let check = new Date(year, month, day);
      let nowDate = this.selectedDate;
      let dateCheck = formatDate(check, 'yyyyMMdd', 'en-US');
      let nowDateLong = formatDate(nowDate, 'yyyyMMdd', 'en-US');
      return parseInt(dateCheck) == parseInt(nowDateLong);
    } else {
      return false;
    }

  }

  dateBtnClass(year, month, day) {
    return {
      today: this.isDateToday(year, month, day),
      selected: this.isSelectedDate(year, month, day)
    };
  }

  selectDate(year, month, day) {
    if (!this.dateUnavailable(year, month, day)) {
      this.selectedDate = new Date(year, month, day);
      this.shared.sendEvent({type: 'delivery_date', data: this.selectedDate});
      setTimeout(() => {
        this.dialogRef.close();
      }, 300);


    }
  }
}
